import { createContext } from "react";
import { Outlet } from "react-router-dom";

import { MantineProvider } from "@mantine/core";
import "@mantine/core/styles.css";
import { ModalsProvider } from "@mantine/modals";
import { Notifications } from "@mantine/notifications";
import "@mantine/notifications/styles.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

import { Layout } from "./components/layout/Layout.tsx";
import KeycloakAuthenticator from "./keycloak/KeycloakAuthenticator.tsx";

const queryClient = new QueryClient();
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);
const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
export const TimezoneContext = createContext(browserTimezone);

export const App = () => {
  return (
    <MantineProvider
      theme={{
        colors: {
          brand: [
            "#ee0b6f",
            "#dd0a73",
            "#cc0977",
            "#bb087c",
            "#aa0780",
            "#990684",
            "#870488",
            "#76038c",
            "#650291",
            "#540195"
          ]
        },
        primaryColor: "brand"
      }}
    >
      <Notifications position="top-right" />
      <KeycloakAuthenticator>
        <QueryClientProvider client={queryClient}>
          <ModalsProvider>
            <TimezoneContext.Provider value={browserTimezone}>
              <Layout>
                <Outlet />
              </Layout>
            </TimezoneContext.Provider>
          </ModalsProvider>
        </QueryClientProvider>
      </KeycloakAuthenticator>
    </MantineProvider>
  );
};

export default App;
